import React from 'react';
import { translate } from 'react-i18next';

import InviteEdit from './edit';
import CopyToClipboardBtn from './CopyToClipboardBtn';

const Item = ({
  t,
  invite,
  isAlreadyAccepted,
  onUndoCancel,
  onCancel,
  onEditSuccess,
}) => (
  <div className="c-box-primary__box u-display-flex u-justify-content-between u-align-items-center">
    <div className="c-box-primary__text u-flex-2">{invite.userMeta.name}</div>
    <div className="c-box-primary__text u-flex-3">{invite.email}</div>

    {invite.status === 'SENT' && (
      <div className="c-box-primary__text u-flex-4 u-display-flex u-flex-column u-align-items-start">
        <p className="u-margin-left-micro u-margin-bottom-micro u-weight-normal">
          {t(`admin.inviteStatusLabel.${invite.status}`)}
        </p>
        <div className="u-display-flex u-flex-wrap">
          <CopyToClipboardBtn
            text={`${window.location.origin}/invite/${invite.code}`}
          />
          <button
            onClick={() => onCancel(invite.code)}
            className="c-btn c-btn--basic c-btn--danger c-btn--effect"
          >
            {t('admin.cancelBtn')}
          </button>
        </div>
      </div>
    )}
    {invite.status === 'CANCELED' && (
      <div className="c-box-primary__text u-flex-4 u-display-flex u-flex-column u-align-items-start">
        <p className="u-margin-left-micro u-margin-bottom-micro u-weight-normal">
          {t(`admin.inviteStatusLabel.${invite.status}`)}
        </p>
        <div className="u-display-flex u-flex-wrap">
          <button
            className="c-btn c-btn--basic c-btn--danger c-btn--effect"
            onClick={() => onUndoCancel(invite.code)}
          >
            {t('admin.undoCancelBtn')}
          </button>
        </div>
      </div>
    )}
    {invite.status === 'ACCEPTED' && (
      <div className="c-box-primary__text u-flex-4 u-display-flex u-flex-column u-align-items-start">
        <p className="u-margin-left-micro u-weight-normal u-color-fountain-blue">
          {t(`admin.inviteStatusLabel.${invite.status}`)}
        </p>
      </div>
    )}

    {/* Edit is only allowed for the invite with status SENT. */}
    {invite.status === 'SENT' ? (
      <div className="u-text-right u-flex-1">
        <InviteEdit onSuccess={onEditSuccess} invite={invite} />
      </div>
    ) : (
      <div className="u-text-right u-flex-1" />
    )}
  </div>
);

export default translate()(Item);



// WEBPACK FOOTER //
// ./src/admin/invites/Item.js